import mitt from 'mitt'

export type MessageCommands = {
  'backgroundMusic.play'?: { replay: boolean }
  'backgroundMusic.pause': undefined
  'backgroundMusic.next'?: { startPlay: boolean }
  'backgroundMusic.select'?: { track: number; startPlay: boolean }
  'backgroundMusic.info': undefined
}

export const commands = mitt<MessageCommands>()
